import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaListUl, FaGripHorizontal } from "react-icons/fa";
import { toast } from "react-toastify";
import Cookies from "js-cookie";

import {
  AddItemToWishList,
  getProductsBySearchTerm,
  GetWishListItems,
  RemoveItemFromWishList,
} from "../Data";

import ProductGridAR from "../Common/ProductGridAR";
import ProductListAR from "../Common/ProductListAR";
import ProductModalAR from "../Common/ProductModalAR";
import Pagination from "../Pagination/Pagination";

const SearchedProductAR = () => {
  const [showList, setShowList] = useState("grid");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchedItems, setSearchedItems] = useState([]);
  const [searchedItemsCount, setSearchedItemsCount] = useState(0);
  const [WishListItems, setWishListItems] = useState([]);
  const [isLogged, setIsLogged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [productDetails, setProductDetails] = useState(null);

  const navigate = useNavigate();
  const params = useParams();
  const LIMIT = 15;
  const token = Cookies.get("CustomerToken");

  /* =========================
     FETCH SEARCH RESULTS
  ========================== */
  useEffect(() => {
    setIsLoading(true);

    getProductsBySearchTerm(params.Term, currentPage, LIMIT)
      .then((res) => {
        setSearchedItems(res?.SearhcedProducts || []);
        setSearchedItemsCount(res?.ProductCount || 0);
      })
      .catch(() => toast.error("فشل تحميل النتائج"))
      .finally(() => setIsLoading(false));
  }, [params.Term, currentPage]);

  /* =========================
     WISHLIST STATE
  ========================== */
  useEffect(() => {
    setIsLogged(!!Cookies.get("CustomerToken"));

    const wishlistId = Cookies.get("WishList");
    if (!wishlistId) return;

    const groupId = wishlistId ? 4 : 3;

    GetWishListItems(wishlistId, groupId, token).then((res) => {
      setWishListItems(res?.WishlistItems || []);
    });
  }, []);

  /* =========================
     WISHLIST ACTIONS
  ========================== */
  const HandleAddToWishList = (ProductId, ProductVariationId) => {
    if (!isLogged) {
      navigate("/Authentication");
      return;
    }

    const wishlistId = Cookies.get("WishList");
    if (!wishlistId) return;

    AddItemToWishList(wishlistId, ProductId, ProductVariationId, token)
      .then((res) => {
        if (!res.ok) throw new Error();
        toast.success("تمت الإضافة إلى المفضلة");

        setWishListItems((prev) => [
          ...prev,
          { ProductId, DefaultProductVariationId: ProductVariationId },
        ]);
      })
      .catch(() => toast.error("تعذرت الإضافة"));
  };

  const HandleRemoveFromWishList = (ProductId) => {
    if (!isLogged) {
      navigate("/Authentication");
      return;
    }

    const wishlistId = Cookies.get("WishList");
    if (!wishlistId) return;

    RemoveItemFromWishList(ProductId, wishlistId, token)
      .then((res) => {
        if (!res.ok) throw new Error();
        toast.success("تمت الإزالة من المفضلة");

        setWishListItems((prev) =>
          prev.filter((x) => x.ProductId !== ProductId)
        );
      })
      .catch(() => toast.error("تعذرت الإزالة"));
  };

  /* =========================
     RENDER
  ========================== */
  return (
    <>
      {/* VIEW MODE */}
      <div className="shop-header mb-3 mt-5 directionRtl">
        <div className="row">
          <div className="col-12 d-flex align-items-center">
            <div className="view-mode-icons directionLtr">
              <a
                className={showList === "grid" ? "active" : ""}
                onClick={() => setShowList("grid")}
              >
                <FaGripHorizontal />
              </a>
              <a
                className={showList === "list" ? "active" : ""}
                onClick={() => setShowList("list")}
              >
                <FaListUl />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* PRODUCTS */}
      {isLoading ? (
        <div className="spinner-container">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <div className="shop-product-wrap row no-gutters mb-3">
          {searchedItems.length > 0 ? (
            searchedItems.map((product) => (
              <div
                key={product.ProductId}
                className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12"
              >
                {showList === "grid" && (
                  <ProductGridAR
                    product={product}
                    WishListItems={WishListItems}
                    HandleAddToWishList={HandleAddToWishList}
                    HandleRemoveFromWishList={HandleRemoveFromWishList}
                    setShowModal={setShowModal}
                    setProductDetails={setProductDetails}
                  />
                )}

                {showList === "list" && (
                  <ProductListAR
                    product={product}
                    WishListItems={WishListItems}
                    HandleAddToWishList={HandleAddToWishList}
                    HandleRemoveFromWishList={HandleRemoveFromWishList}
                    setShowModal={setShowModal}
                    setProductDetails={setProductDetails}
                  />
                )}
              </div>
            ))
          ) : (
            <h2 className="text-center mt-5">لا توجد منتجات</h2>
          )}
        </div>
      )}

      {/* PAGINATION */}
      {searchedItemsCount > LIMIT && (
        <Pagination
          currentPage={currentPage}
          totalCount={searchedItemsCount}
          pageSize={LIMIT}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}

      {/* MODAL */}
      {showModal && productDetails && (
        <ProductModalAR
          productDetails={productDetails}
          WishListItems={WishListItems}
          HandleAddToWishList={HandleAddToWishList}
          HandleRemoveFromWishList={HandleRemoveFromWishList}
          showModal={showModal}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};

export default SearchedProductAR;
